import React from 'react';
import pauseVintagePhotoSrc from '../../assets/images/slide/pause-vintage-photo.png';
import styles from './PauseSlideContentV7.css';

const STATS = [
    {
        id: 1,
        percent: '53%',
        title: 'of people',
        description: 'can\'t name all four of their grandparents',
        source: 'Source: Poste / Canalymedia, 2019'
    },
    {
        id: 2,
        percent: '8%',
        title: 'of people',
        description: 'who heard a family story ever wrote it down',
        source: 'Source: LifeBook, 2014'
    }
];

function PauseSlideContentV7() {
    return (
        <div className={styles.form}>
            <div className={styles.imageWrapper}>
                <img src={pauseVintagePhotoSrc} alt='' className={styles.image} />
            </div>
            <div className={styles.content}>
                <div className={styles.headingSection}>
                    <h2 className={styles.heading}>Your story started in a different world</h2>
                    <p className={styles.description}>The music, routines, expectations, and turning points of your generation all shaped who you became. Boundly uses your decade to ask questions that feel relevant to the life you actually lived.</p>
                </div>
                <ul className={styles.stats}>
                    {STATS.map(stat => (
                        <li key={stat.id} className={styles.statCard}>
                            <span className={styles.statBadge}>{stat.percent}</span>
                            <div className={styles.statText}>
                                <p className={styles.statTitle}>{stat.title}</p>
                                <p className={styles.statDescription}>{stat.description}</p>
                                <p className={styles.statSource}>{stat.source}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export {
    PauseSlideContentV7
};
